import React, { useRef, useState } from 'react';
import { Content } from '../../styles/navbar.style';

import Icon_Menu from '../../../../images/Icons/menu.svg';
import Icon_Close from '../../../../images/Icons/at_x.svg';
import { MenuButton } from '../../styles/mobileNavbar.style';
import BrandLogo from '../BrandLogo';
import MobileDropdown from '../MobileDropdown';
import PropTypes from 'prop-types';

const MobileNavbar = (props) => {
    const [isMobileDropdownActive, setIsMobileDropdownActive] = useState(false);
    const menuButtonRef = useRef(null);

    const onCloseMobileMenu = () => {
        setIsMobileDropdownActive(false);
        props?.setActiveMenu('');
        props?.setActiveDropdownCategory('');
    };

    const toggleMobileMenu = () => {
        setIsMobileDropdownActive((prev) => !prev);
        if (isMobileDropdownActive) {
            onCloseMobileMenu();
        }
    };

    return (
        <>
            <Content>
                <BrandLogo />
                <MenuButton ref={menuButtonRef} onClick={toggleMobileMenu}>
                    <img src={isMobileDropdownActive ? Icon_Close : Icon_Menu} alt="menu-icon" />
                </MenuButton>
            </Content>
            {isMobileDropdownActive && (
                <MobileDropdown
                    {...props}
                    menuButtonRef={menuButtonRef}
                    setIsMobileDropdownActive={setIsMobileDropdownActive}
                    onCloseMobileMenu={onCloseMobileMenu}
                />
            )}
        </>
    );
};

MobileNavbar.propTypes = {
    setActiveMenu: PropTypes.func,
    setActiveDropdownCategory: PropTypes.func,
};

export default MobileNavbar;
